import { sortFields } from 'constants/sortFields';
import { FC, HTMLProps } from 'react';
import { useTranslation } from 'utils/i18n';

export type SortOption = keyof typeof sortFields;

interface Props extends HTMLProps<HTMLSelectElement> {
  label?: string;
  sortOptions?: SortOption[];
}

const SortDropDown: FC<Props> = ({
  label,
  sortOptions = Object.keys(sortFields),
  ...props
}) => {
  const { t } = useTranslation('common');
  const defaultLabel = label || t('sort_by');

  return (
    <div className="sort-dropdown">
      <div className="sort-dropdown__select">
        <select name="select-sort-option" aria-label={defaultLabel} {...props}>
          {sortOptions.map(field => (
            <option key={field} value={field}>
              {field}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SortDropDown;
